import { types } from './types';

const INITIAL_STATE = {
    initiated: false,
    loading: false,
    hasError: false,
    hasInfo: false,
    message: "",
    gsisAuthUrl: null,
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.SET_FORM_INITIATED:
      return {
        ...state,
        initiated: true,
      };
    case types.SET_FORM_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.UNSET_FORM_LOADING:
      return {
        ...state,
        loading: false,
      };
    case types.UPDATE_FORM_PROPERTIES.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.SET_FORM_ERROR:
      return {
        ...state,
        hasError: true,
        hasInfo: false,
        message: payload,
      };
    case types.SET_FORM_INFO:
      return {
        ...state,
        hasError: false,
        hasInfo: true,
        message: payload,
      };
    case types.UNSET_FORM_MESSAGE:
      return {
        ...state,
        hasError: false,
        hasInfo: false,
        message: "",
      };
    case types.RESET_FORM:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case types.SET_FORM_GSIS_AUTH:
      return {
        ...state,
        gsisAuthUrl: payload,
      };
    default:
    return state;
  }
};

export default reducer;
